/**
 * Bereinigter Grundwortschatz aus der bisherigen Blitzlesen-Liste.
 * Doppelte Einträge wurden entfernt; die Liste wird beim Seed in die Datenbank
 * geschrieben und ist danach vollständig über das CMS verwaltbar.
 */
export const GRUNDWORTSCHATZ_HESSEN = `
acht
alt
Angst
Ast
Baum
Bein
blau
braun
breit
Brief
Brot
Buch
bunt
Dach
drei
Ei
eins
Eis
elf
Fach
fein
feucht
Fisch
Frau
frisch
fünf
gleich
Gras
grün
gut
Hals
Haus
Heft
Hut
jung
kalt
klein
Knie
Kopf
Kraut
Kreis
lang
laut
leicht
Licht
Loch
los
Luft
Maus
Mensch
Milch
Nacht
neu
neun
Pilz
reich
Ring
rot
Saft
Salz
Schal
schief
schön
Schrift
Seil
Tisch
tun
weit
Welt
Zaun
Zeit
zwei
zwölf
Ameise
Auge
Biene
Blume
Blüte
böse
Ende
Ente
Eule
Freude
Gemüse
Hase
heute
Hose
Junge
Küche
leise
Leute
Name
Nase
Ochse
Pflaume
Raupe
Riese
Sache
Schere
Schlange
Seife
Seite
Tante
Tasche
Wiese
Woche
bauen
biegen
bleiben
brauchen
bringen
dachten
fangen
finden
fliegen
fragen
freuen
Frieden
frieren
geben
halten
helfen
holen
hören
impfen
kaufen
kleben
kochen
kriechen
kriegen
Kuchen
lachen
laufen
leben
legen
lesen
leuchten
liegen
machen
malen
oben
pflanzen
pflegen
rechnen
reden
Regen
reisen
riechen
rufen
sagen
schauen
scheinen
schieben
schimpfen
schlafen
schlagen
schneiden
schreiben
schreien
schweigen
sieben
singen
suchen
tragen
üben
unten
waschen
wünschen
zeigen
zwischen
Ampel
Apfel
Bügel
Flügel
Gabel
Insel
Nebel
Nabel
Nudel
Pinsel
Schnabel
Tafel
Teufel
Windel
Zwiebel
Bruder
erster
euer
Fenster
Feuer
Finger
Hunger
keiner
Kleber
leider
Leiter
Meter
Pflaster
Schwester
selber
Tochter
anders
Eltern
flüstern
gestern
hundert
Ostern
Bier
Flur
Papier
Schnur
schwer
Tier
Tor
Tür
antworten
Birne
dort
Durst
Erde
erst
gerne
Gurke
Herz
Kirche
Kirsche
Körper
kurz
lernen
merken
morgen
turnen
Wort
Würfel
Wurm
Wurst
Wurzel
arbeiten
Arm
Farbe
hart
klar
Marke
Nachbar
scharf
sogar
schwarz
warm
warten
als
auch
auf
aus
bei
bist
da
dein
dem
den
dich
die
dies
doch
du
ein
euch
ganz
ich
ist
ja
kein
mein
mich
nach
nein
nicht
nichts
nie
noch
nun
oft
schon
sein
seit
sich
sie
so
uns
weil
wem
wen
wie
wo
zu
der
dir
durch
dürfen
er
für
her
hier
mir
nur
war
wer
werden
zur
am
an
bin
bis
das
des
es
hat
hin
im
in
man
mit
um
warum
was
zum
alle
dann
denn
hatte
immer
können
müssen
sollen
wann
wenn
wollen
ab
bald
seid
sind
und
ihm
ihn
ihr
mehr
sehr
ohne
viel
vom
von
vor
aber
hinter
oder
über
unter
weiter
wieder
also
eure
etwas
gegen
habe
haben
jede
mögen
waren
welche
sparen
Spiegel
spielen
Sport
sprechen
springen
Stein
Stern
Stift
stolz
Strauch
streichen
streiten
Stunde
Sturm
Spaß
spät
Spaziergang
Spinne
spitz
Stadt
Stamm
stark
stehen
stellen
still
Stimme
Stoff
Strand
Straße
Stück
Stuhl
Bank
danken
denken
dunkel
krank
Onkel
Punkt
schenken
Schrank
trinken
bequem
Quadrat
quaken
Qualle
Quark
Quatsch
Quelle
quer
quietschen
Affe
backen
besser
Bett
bitten
blicken
Blitz
Block
brennen
Brille
Brücke
Butter
Decke
dick
doppelt
dreckig
drucken
drücken
dumm
dünn
fett
Fluss
flüssig
fressen
Füller
glatt
Glück
Gott
gucken
hell
Herr
Hessen
Himmel
Hitze
hoffen
Jacke
Katze
kennen
Klasse
klettern
kommen
kratzen
lassen
lecker
Löffel
messen
Messer
Mitte
Mutter
Müll
Mütze
Null
Nummer
Nuss
offen
packen
passen
pflücken
Platz
Puppe
putzen
rennen
rollen
Rock
Rücken
sammeln
schaffen
Schiff
Schloss
Schlüssel
schmecken
Schmutz
schnell
Schreck
schütteln
Schutz
schwimmen
schwitzen
Sessel
setzen
sitzen
Sommer
Sonne
Tanne
Tasse
Teller
toll
treffen
trocken
voll
Wasser
witzig
Zimmer
Zucker
allein
bekommen
bisschen
Donnerstag
entdecken
entwickeln
erinnern
erschrecken
Fußball
hallo
herstellen
hoffentlich
innerhalb
interessant
jetzt
kaputt
letzte
Mittag
Mittwoch
passieren
plötzlich
Programm
Pullover
Pommes
Sonntag
überall
vergessen
verletzen
verstecken
vielleicht
zuletzt
zurück
zusammen
blühen
drehen
früh
gehen
Kuh
nah
Reh
Reihe
Ruhe
Schuh
sehen
Zeh
ziehen
Bahn
bohren
fahren
fehlen
Fehler
fühlen
Höhle
Huhn
Jahr
kühl
Lehrer
nehmen
Ohr
rühren
Uhr
wohl
wohnen
Zahl
Zahn
zehn
ähnlich
bezahlen
erzählen
Fahrrad
Frühling
Frühstück
Gefahr
ungefähr
Verkehr
während
Weihnachten
Beere
Boot
Haar
Idee
leer
Meer
paar
Schnee
See
Tee
Zoo
Abend
Berg
Bild
blind
Feld
fremd
Freund
gelb
genug
genügende
gesund
Grund
Gründe
Hemd
Hund
Kind
Kleid
klug
Krieg
lieb
Lied
Mund
Münder
Pferd
rund
Tag
tausend
Tod
Urlaub
Weg
wild
Wind
Zug
Züge
Flugzeug
Montag
Dienstag
Freitag
Samstag
deshalb
endlich
Ergebnis
Herbst
irgend
jemand
Jugend
Mädchen
niemand
ob
Obst
Ordnung
Sand
selbst
unterwegs
aufräumen
aufwachen
Gesicht
deutlich
eigentlich
nämlich
natürlich
schließlich
fertig
fleißig
Käfig
König
mutig
richtig
riesig
schwierig
vorsichtig
bevor
brav
davon
November
Silvester
Vase
Vater
verbieten
Verein
verlieren
Versuch
verwandt
viele
vier
Virus
Vogel
vorne
vorwärts
Vulkan
Dachs
Fuchs
sechs
Wachs
wachsen
wechseln
boxen
Hexe
Lexikon
Taxi
Text
Baby
Handy
Pony
Teddy
Cent
Clown
Comic
Computer
Chance
Chef
Chor
ärgern
Bär
erklären
hängen
Käfer
Käse
Lärm
März
nächste
Träne
Auto
Bus
E-Mail
Euro
Europa
fair
Ferien
Internet
Kalender
Lineal
Linie
Mai
Maschine
Medien
Minute
Monat
Musik
Paket
Pizza
Radio
Sekunde
Telefon
Temperatur
Theater
Thema
trainieren
Januar
Februar
April
Juni
Juli
August
September
Oktober
Dezember
Igel
Liter
Tiger
bereits
Draht
Geburtstag
links
rechts
außen
beißen
bloß
draußen
fließen
Fuß
gießen
groß
grüßen
heiß
ließen
reißen
schließen
Soße
süß
weiß
Entfernung
Heizung
Zeitung
Zeugnis
`.trim().split(/\r?\n/);
